import { createUseTask } from '@shared';
import { DeduplicationTask } from '../deduplication-task';

const useDeduplicationTaskBase = createUseTask(DeduplicationTask);

export const useDeduplicationTask = () => {
    const task = useDeduplicationTaskBase() as DeduplicationTask;
    return task;
};
